import React, { useState } from "react";
import "./TermsService.scss";
import V_1ServiceContent from "./V_1ServiceContent";
import V_2ServiceContent from "./V_2ServiceContent";

export default function TermsService() {
  const [open, setOpen] = useState(false);
  const [flag, setFlag] = useState({ key: 1, date: "2023.05.18" });

  return (
    <section className="content-area">
      <div className="content-heading">
        <h2>이용약관</h2>
        <div className="content-select" onClick={() => setOpen(!open)}>
          <p>{flag.date}</p>
          <div
            className="black-arrow"
            style={{ transform: open && "rotate(0deg)" }}
          />
          {open && (
            <ul>
              <li onClick={() => setFlag({ key: 1, date: "2023.05.18" })}>
                2023.05.18
              </li>
              <li onClick={() => setFlag({ key: 2, date: "2022.06.07" })}>
                2022.06.07
              </li>
            </ul>
          )}
        </div>
      </div>
      {flag.key === 1 && <V_2ServiceContent />}
      {flag.key === 2 && <V_1ServiceContent />}
    </section>
  );
}
